<template>
  <div class="hero">
    <div class="container">
      <div class="hero__wrapper">
        <div class="hero__left">
          <img class="hero__left-image" src="@images/heroCard1.png" alt="card" loading="lazy">
          <img class="hero__left-image" src="@images/heroCard2.png" alt="card" loading="lazy">

          <img class="hero__left-vector hero__left-vector1" src="@images/vectors/hero/pinkVector.svg" alt="vector" loading="lazy">
          <img class="hero__left-vector hero__left-vector2" src="@images/vectors/hero/yellowStar.svg" alt="vector" loading="lazy">
          <img class="hero__left-vector hero__left-vector3" src="@images/vectors/hero/purpleVector.svg" alt="vector" loading="lazy">
          <img class="hero__left-vector hero__left-vector4" src="@images/vectors/hero/purpleStar.svg" alt="vector" loading="lazy">
          <img class="hero__left-vector hero__left-vector5" src="@images/vectors/hero/whiteVector.svg" alt="vector" loading="lazy">
          <img class="hero__left-vector hero__left-vector6" src="@images/vectors/hero/blueVector.svg" alt="vector" loading="lazy">
        </div>
        <div class="hero__right">
          <h1 class="hero__right-title">PREPAID CARDS -</h1>
          <p class="hero__right-subtitle">{{ t('home.hero.subtitle') }}</p>
          <div class="hero__right-buttons">
            <img src="@images/vectors/hero/heroText.svg" alt="text">
            <router-link :to="translations.i18nRoute({ name: 'store' })" class="hero__right-button hero__right-button1">{{ t('buttons.shop') }}</router-link>
            <router-link :to="translations.i18nRoute({ name: 'faq' })" class="hero__right-button hero__right-button2">{{ t('buttons.about') }}</router-link>
          </div>
          <div class="hero__right-info">
            <div>
              <h6>2М+</h6>
              <p>{{ t('home.hero.customers') }}</p>
            </div>
            <div>
              <h6>€3M+</h6>
              <p>{{ t('home.hero.revenue') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="hero__logo" src="@icons/logo.png" alt="logo">
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.hero {
  padding-block: 80px 100px;
  background: linear-gradient(180.00deg, rgba(168, 244, 149, 0) 55.397%,rgb(245, 250, 206) 100%);
  position: relative;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  &__left {
    background: linear-gradient(180.00deg, rgb(190, 233, 252),rgb(215, 237, 255) 100%);
    width: 520px;
    height: 655px;
    border-radius: 40px;
    position: relative;

    &-image {
      width: 100%;
      position: absolute;
      top: 140px;
      left: 40px;
      z-index: 0;

      &:first-child {
        top: -50px;
        left: 0;
        z-index: 1;
      }
    }

    &-vector {
      position: absolute;
    }
    &-vector1 {
      top: -20px;
      left: -45px;
    }
    &-vector2 {
      top: -30px;
      right: 15px;
    }
    &-vector3 {
      top: 150px;
      left: -70px;
    }
    &-vector4 {
      bottom: 140px;
      right: 40px;
    }
    &-vector5 {
      right: 90px;
      bottom: 45px;
    }
    &-vector6 {
      bottom: -30px;
      left: -40px;
    }
  }

  &__right {
    &-title {
      font-family: Poppins, sans-serif;
      font-size: 64px;
      font-weight: 700;
      color: #2a2a2a;
    }

    &-subtitle {
      max-width: 517px;
      font-size: 24px;
      font-weight: 400;
      line-height: 29px;
      color: #4a4a4a;
    }

    &-buttons {
      margin-top: 50px;
      display: flex;
      align-items: center;
      gap: 10px;
    }

    &-button {
      cursor: pointer;
      padding: 15px 25px;
      border-radius: 4px;
      font-family: Poppins,sans-serif;
      font-size: 18px;
      font-weight: 500;
      transition: 0.2s;
    }
    &-button1 {
      background-color: $black;
      color: $white;

      @include hover {
        background-color: #5b5b5b;
      }
    }
    &-button2 {
      background-color: transparent;
      border: 1px solid $black;

      @include hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    &-info {
      margin-top: 50px;
      display: flex;
      gap: 100px;

      & h6 {
        font-family: Poppins, sans-serif;
        font-size: 56px;
        font-weight: 400;
        color: #4a4a4a;
      }

      & p {
        font-family: Poppins, sans-serif;
        font-size: 18px;
        color: #4a4a4a;
      }
    }
  }

  &__logo {
    width: 150px;
    position: absolute;
    bottom: 50px;
    right: 50px;
  }
}

@media (max-width: 1300px) {
  .hero {
    &__wrapper {
      flex-direction: column-reverse;
      gap: 75px;
    }
  }
}

@media (max-width: 650px) {
  .hero {
    &__left {
      width: 80%;
    }

    &__right {
      display: flex;
      flex-direction: column;
      align-items: center;

      &-title {
        font-size: 36px;
      }

      &-subtitle {
        width: 75%;
        text-align: center;
        font-size: 18px;
        line-height: 22px;
      }

      &-buttons {
        & img {
          width: 150px;
        }
      }

      &-button {
        font-size: 14px;
        padding: 10px 15px;
      }

      &-info {
        gap: 50px;

        & h6 {
          font-size: 48px;
        }

        & p {
          font-size: 14px;
        }
      }
    }
  }
}

@media (max-width: 650px) {
  .hero {
    padding-bottom: 150px;

    &__logo {
      bottom: 0;
      right: 0;
    }

    &__left {
      height: 475px;
    }
  }
}
</style>